import React, { useState } from 'react';

import IconButton from 'components/IconButton';
import { PartialPopover } from 'components/Popover';
import { useGlobalLinks, usePermissions } from 'hooks';
import { cn } from 'utils/classNames';
import { useI18n } from 'utils/i18n';

/** Feedback form trigger for staff and other permitted users */
export default function UserFeedback() {
	const { t } = useI18n();
	const { userFeedback } = useGlobalLinks();

	const { error, isLoading, permissions } = usePermissions('Feedback');
	const [isFormOpen, setIsFormOpen] = useState(false);

	if (!permissions?.feedbackAllowed || error || isLoading) {
		return null;
	}
	return (
		<>
			<IconButton
				icon="lightbulb"
				variant="branded"
				text={t('floating_user_feedback_button_text')}
				className={cn(
					'border-2 border-inverse transition-opacity focus-visible:focus-outline-inverted forced-colors:border print:hidden [&:not(:focus-visible)]:shadow-lg',
					isFormOpen && 'opacity-0',
				)}
				onClick={() => setIsFormOpen(true)}
			/>
			{userFeedback && (
				<PartialPopover
					heading={t('feedback_form_title')}
					isOpen={isFormOpen}
					item={userFeedback}
					onClose={() => setIsFormOpen(false)}
				/>
			)}
		</>
	);
}
UserFeedback.displayName = 'UserFeedback';
